var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.26601 9.765C5.73389 8.34945 6.63687 7.11781 7.84612 6.2458C9.05538 5.37378 10.5091 4.90594 12 4.909C13.69 4.909 15.218 5.509 16.418 6.491L19.91 3C17.782 1.145 15.055 0 12 0C7.27001 0 3.19801 2.698 1.24001 6.65L5.26601 9.765Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.04 18.013C14.95 18.716 13.566 19.091 12 19.091C10.5151 19.0941 9.0668 18.6299 7.86024 17.7644C6.65367 16.8988 5.74994 15.6756 5.277 14.268L1.237 17.335C2.22824 19.3413 3.76227 21.0294 5.66482 22.2076C7.56738 23.3857 9.7622 24.0067 12 24C14.933 24 17.735 22.957 19.834 21L16.041 18.013H16.04Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.834 21C22.029 18.952 23.454 15.904 23.454 12C23.454 11.29 23.345 10.527 23.182 9.81799H12V14.455H18.436C18.119 16.014 17.266 17.221 16.041 18.013L19.834 21Z",
    fill: "#4A90E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27699 14.268C5.03235 13.5369 4.90806 12.7709 4.90899 12C4.90899 11.218 5.03399 10.467 5.26599 9.76499L1.23999 6.64999C0.416372 8.31268 -0.00820201 10.1445 -5.61577e-06 12C-5.61577e-06 13.92 0.444994 15.73 1.23699 17.335L5.27699 14.268Z",
    fill: "#FBBC05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.663d34b9162ebc2064d8eb51ddf0b75a.svg";
export { ForwardRef as ReactComponent };